"use client";

import QrScanner from "qr-scanner";
import { useEffect, useRef, useState } from "react";

export function StandaloneQrScanner({
  active,
  onPayload,
}: {
  active: boolean;
  onPayload: (payload: string) => void;
}) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const scannerRef = useRef<QrScanner | null>(null);
  const lastPayloadRef = useRef({ value: "", at: 0 });
  const [error, setError] = useState("");

  useEffect(() => {
    if (!active || !videoRef.current) return;
    const video = videoRef.current;
    let cancelled = false;
    const scanner = new QrScanner(
      video,
      (result) => {
        const payload = typeof result === "string" ? result : result.data;
        const now = Date.now();
        if (
          payload === lastPayloadRef.current.value &&
          now - lastPayloadRef.current.at < 2500
        ) {
          return;
        }
        lastPayloadRef.current = { value: payload, at: now };
        onPayload(payload);
      },
      {
        preferredCamera: "environment",
        maxScansPerSecond: 8,
        returnDetailedScanResult: true,
      },
    );
    scannerRef.current = scanner;
    setError("");
    void scanner.start().catch((reason: unknown) => {
      if (cancelled) return;
      const message = String(reason).toLowerCase();
      setError(
        message.includes("permission") || message.includes("denied")
          ? "Permissão da câmera recusada. Use Digitar manualmente."
          : "Não foi possível abrir a câmera neste dispositivo. Use Digitar manualmente.",
      );
    });

    return () => {
      cancelled = true;
      scanner.destroy();
      scannerRef.current = null;
    };
  }, [active, onPayload]);

  return (
    <div className="space-y-3">
      <div className="overflow-hidden rounded-xl bg-slate-950">
        <video
          ref={videoRef}
          className="aspect-video w-full object-cover"
          playsInline
          muted
          aria-label="Câmera para leitura do QR code"
        />
      </div>
      <p className="text-center text-xs text-slate-500 dark:text-slate-400">
        Aponte a câmera traseira para o QR code.
      </p>
      {error ? (
        <p className="rounded-md bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:bg-amber-950/40 dark:text-amber-200">
          {error}
        </p>
      ) : null}
    </div>
  );
}
